export default {"src":"/_next/static/media/warning.dc8ec224.svg","height":48,"width":49};